import { render, staticRenderFns } from "./onfleet-driver-sms-template-grid.vue?vue&type=template&id=610ed18e"
import script from "./onfleet-driver-sms-template-grid.vue?vue&type=script&lang=js"
export * from "./onfleet-driver-sms-template-grid.vue?vue&type=script&lang=js"
import style0 from "./onfleet-driver-sms-template-grid.vue?vue&type=style&index=0&id=610ed18e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports